import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-serivce',
  templateUrl: './service-serivce.component.html',
  styleUrls: ['./service-serivce.component.scss']
})
export class ServiceSerivceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
